// @flow

const DMS_ROUTE_KEYS = {
	DMS_DEFAULT: 'default',
	DMS_UNKNOWN: 'unknown',

	DMS_TABS: 'tab',
	DMS_VIEW_MODE: 'view',
	DMS_OFFICE_ON_MAP: 'map',

	DMS_FILTERS_ASSISTANCE_TYPE: 'filters-assistance-type',
};


export {
	DMS_ROUTE_KEYS,
};


export const ROUTE_NAME_DMS_INSURED_DEFAULT = 'dms-insured-default';
export const ROUTE_NAME_DMS_INSURED_UNKNOWN = 'dms-insured-unknown';

export const ROUTE_NAME_DMS_INSURED = 'dms-insured';
export const ROUTE_NAME_DMS_INSURED_WITH_VIEW = 'dms-insured-with-view';
export const ROUTE_NAME_DMS_INSURED_WITH_VIEW_OFFICE_ON_MAP = 'dms-insured-with-view-office-on-map';
export const ROUTE_NAME_DMS_INSURED_WITH_VIEW_FILTERS_TYPES = 'dms-insured-with-view-filters-types';

//
export const ROUTE_PART_POLICY_ID = 'policyId';
export const ROUTE_PART_TAB_NAME = 'tabName';
export const ROUTE_PART_VIEW_NAME = 'viewName';
